import { Space } from '@billy/design-system'
import { memo } from 'react'

import { Difference } from '@modules-deprecated/bankReconciliation/types'

import { ExchangeRateDeviationWarning } from '../../../../..//paymentReconciliationModal/elements/ExchangeRateDeviationWarning'
import { DifferenceSelector } from '../../../../../paymentReconciliationModal/elements/DifferenceSelector'

interface BankLinesModalInfoProps {
  isCrossCurrency: boolean
  showDifferenceSelector: boolean
  bankLinesDifference: Difference
}

export const BankLinesModalInfo = memo(
  ({ isCrossCurrency, showDifferenceSelector, bankLinesDifference }: BankLinesModalInfoProps) => {
    if (!isCrossCurrency) {
      return showDifferenceSelector && <DifferenceSelector difference={bankLinesDifference} />
    }

    return (
      <>
        <Space size="s12" />
        <ExchangeRateDeviationWarning />
      </>
    )
  },
)
